import styled from "@emotion/styled";
import {
  LoveHandles,
  SortableCustomTable,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledAccountsDetailsTidContainerDiv = styled("div")({
  marginBlock: "40px",
});

export const StyledAccountsDetailsTidHeaderDiv = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});

export const StyledLoveHandles = styled(LoveHandles)({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  paddingInline: "40px",
  paddingBlock: "32px",
});

export const StyledAddButtonRowDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

export const StyledTableContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

export const StyledSortableCustomTable = styled(SortableCustomTable)({
  margin: 0,
});

export const StyledCountText = styled(Text)(({ theme }) => ({
  color: theme.palette.grey[500],
  textAlign: "center",
}));

export const StyledCompanyNameDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
});
